import * as m from "three";
import { defineQuery as V } from "bitecs";
import "../../core/ecs/components.js";
import "../../core/validation/schemas.js";
import { WorldTransform as g } from "../transforms/components.js";
import "../transforms/systems.js";
import "../rendering/components.js";
import "../rendering/systems.js";
import { getScene as k, getRenderingContext as C } from "../rendering/utils.js";
import { Line as n } from "./components.js";
import { getLineContext as L, getMaterialKey as v, getOrCreateBatch as A, disposeBatch as M } from "./utils.js";
const B = V([n, g]), P = Math.PI / 6;
function x(l, r, s, e, i) {
  const a = new m.Vector3().subVectors(r, l).normalize(), d = e ? l.clone() : r.clone(), t = e ? a : a.clone().negate(), o = new m.Vector3();
  Math.abs(a.y) < 0.9 ? o.crossVectors(a, new m.Vector3(0, 1, 0)).normalize() : o.crossVectors(a, new m.Vector3(1, 0, 0)).normalize();
  const p = i === 0 ? P : -P, f = t.clone().applyAxisAngle(o, p).multiplyScalar(s), c = d.clone().add(f);
  return { tip: d, wingEnd: c };
}
function y(l, r, s, e, i) {
  l.push(s.x, s.y, s.z, e.x, e.y, e.z), r.push(i.r, i.g, i.b, i.r, i.g, i.b);
}
function D(l) {
  const r = [], s = [];
  for (const e of l) {
    if (!e.visible || !Number.isFinite(e.startPos.x) || !Number.isFinite(e.endPos.x)) continue;
    const i = e.endPos.x - e.startPos.x, a = e.endPos.y - e.startPos.y, d = e.endPos.z - e.startPos.z;
    if (i * i + a * a + d * d > 1e-10) {
      if (y(r, s, e.startPos, e.endPos, e.color), e.arrowStart && e.arrowSize > 0)
        for (let o = 0; o < 2; o++) {
          const { tip: p, wingEnd: f } = x(
            e.startPos,
            e.endPos,
            e.arrowSize,
            !0,
            o
          );
          y(r, s, p, f, e.color);
        }
      if (e.arrowEnd && e.arrowSize > 0)
        for (let o = 0; o < 2; o++) {
          const { tip: p, wingEnd: f } = x(
            e.startPos,
            e.endPos,
            e.arrowSize,
            !1,
            o
          );
          y(r, s, p, f, e.color);
        }
    }
  }
  return { positions: r, colors: s };
}
const I = {
  group: "draw",
  update(l) {
    const r = k(l);
    if (!r) return;
    const s = C(l), e = L(l), i = B(l.world);
    if (s?.renderer) {
      e.resolution.set(
        s.renderer.domElement.width,
        s.renderer.domElement.height
      );
      for (const t of e.batches.values())
        t.material.resolution.copy(e.resolution);
    }
    const a = /* @__PURE__ */ new Map();
    for (const t of i) {
      const o = n.thickness[t], p = n.opacity[t], f = v(o, p), c = new m.Vector3(
        g.posX[t],
        g.posY[t],
        g.posZ[t]
      ), u = new m.Vector3(
        n.offsetX[t] * g.scaleX[t],
        n.offsetY[t] * g.scaleY[t],
        n.offsetZ[t] * g.scaleZ[t]
      ), h = new m.Vector3(
        c.x + u.x,
        c.y + u.y,
        c.z + u.z
      ), b = Math.sqrt(
        n.offsetX[t] ** 2 + n.offsetY[t] ** 2 + n.offsetZ[t] ** 2
      ), z = u.length(), S = b > 0 ? z / b : 1, E = {
        entity: t,
        startPos: c,
        endPos: h,
        color: new m.Color(n.color[t]),
        arrowStart: n.arrowStart[t] === 1,
        arrowEnd: n.arrowEnd[t] === 1,
        arrowSize: n.arrowSize[t] * S,
        visible: n.visible[t] === 1
      };
      let w = a.get(f);
      w || (w = [], a.set(f, w)), w.push(E);
    }
    const d = /* @__PURE__ */ new Set();
    for (const [t, o] of a) {
      d.add(t);
      const p = n.thickness[o[0].entity], f = n.opacity[o[0].entity], c = A(e, t, p, f, r), { positions: u, colors: h } = D(o);
      u.length > 0 ? (delete c.geometry._maxInstanceCount, c.geometry.setPositions(u), c.geometry.setColors(h), c.segments.computeLineDistances(), c.segments.visible = !0) : c.segments.visible = !1;
    }
    for (const [t, o] of e.batches)
      d.has(t) || (M(o, r), e.batches.delete(t));
  }
};
export {
  I as LineSystem
};
//# sourceMappingURL=systems.js.map
